import React, { Component } from 'react';
import SquarePaymentForm from './SquarePaymentForm';
import './SquareStyles.css';

class SquareCreditCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    const that = this;
    let sqPaymentScript = document.createElement('script');
    sqPaymentScript.src = this.props.jsUrl;
    sqPaymentScript.type = 'text/javascript';
    sqPaymentScript.async = false;
    sqPaymentScript.onload = () => {
      that.setState({
        loaded: true,
      });
    };
    document.getElementsByTagName('head')[0].appendChild(sqPaymentScript);
  }

  render() {
    return (
      this.state.loaded && (
        <SquarePaymentForm {...this.props} sqPayments={window.Square.payments} country={this.props.country} />
      )
    );
  }
}

export default SquareCreditCard;
